// Module
var code = "<div class=\"widget-content relative\"> <wt-loading-panel is-loading=\"vm.isLoading\"></wt-loading-panel> <wt-dependencies id=\"{{vm.prefix}}\" configuration=\"vm.configuration\" data=\"vm.data\" class=\"widget\"></wt-dependencies> </div>";
// Exports
module.exports = code;